import { Card, CardContent } from "@material-ui/core";
import arrayMove from "array-move";
import { useEffect, useState } from "react";
import { Error, Loading, SaveButton, Toolbar, useDataProvider, useNotify } from "react-admin";
import { useHistory } from "react-router-dom";
import { MpmRowsGrid } from "../pages/components/mpm-rows-grid";

export const MpmRowByPlatformEdit = (props) => {
  const dataProvider = useDataProvider();
  const history = useHistory();
  const notify = useNotify();
  const [rows, setRows] = useState();
  const [templates, setTemplates] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const loadRows = async () => {
      try {
        const [{ data: rows }, { data: templates }] = await Promise.all([
          dataProvider.getMpmRowsByPlatform(props.id),
          dataProvider.getList("mpm-row-templates", {
            pagination: { page: 1, perPage: 500 },
            sort: { field: "name", order: "ASC" },
            filter: {},
          }),
        ]);

        setRows(rows);
        setTemplates(templates);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    loadRows();
  }, [props.id]);

  if (loading) return <Loading />;
  if (error) return <Error />;
  if (!rows || !templates) return null;

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setRows((rows) => arrayMove(rows, oldIndex, newIndex));
  };

  const onSave = async () => {
    try {
      await dataProvider.updateMpmRowsOrderByPlatformByPlatformId(props.id, rows);
      notify("Saved", "info");
      history.goBack();
    } catch (error) {
      notify(error.message.toString(), "warning");
    }
  };

  return (
    <Card>
      <CardContent>
        <MpmRowsGrid rows={rows} templates={templates} showCreateButton={false} showCloneButton={false} showDeleteButton={false} showPlatformLinks={false} showPlatformOrders={false} showReorderButton={true} onSortEnd={onSortEnd} />
        <Toolbar>
          <SaveButton label="Save" handleSubmitWithRedirect={onSave} />
        </Toolbar>
      </CardContent>
    </Card>
  );
};
